import { defineMessages } from 'react-intl';

export default defineMessages({
    activities: {
        id: 'ent.gatewayviews.activities-landing.Activities',
        defaultMessage: 'Activities',
    },
    advanceFilter: {
        id: 'ent.gatewayviews.activities-landing.Advanced Filter',
        defaultMessage: 'Advanced Filter',
    },
    allOpen: {
        id: 'ent.gatewayviews.activities-landing.All Open',
        defaultMessage: 'All Open',
    },
    createdByYou: {
        id: 'ent.gatewayviews.activities-landing.Created By You',
        defaultMessage: 'Created By You',
    },
    allCompleted: {
        id: 'ent.gatewayviews.activities-landing.All Completed',
        defaultMessage: 'All Completed for past 6 months',
    },
    allCanceled: {
        id: 'ent.gatewayviews.activities-landing.All Canceled',
        defaultMessage: 'All Canceled',
    },
    allUnassigned: {
        id: 'ent.gateway.views.activities-landing.All Canceled',
        defaultMessage: 'All Unassigned'
    },
    yourComplete: {
        id: 'ent.gatewayviews.activities-landing.Your Completed',
        defaultMessage: 'Your Completed for past 6 months',
    },
    yourOpen: {
        id: 'ent.gatewayviews.activities-landing.Your Open',
        defaultMessage: 'Your Open',
    },
    note: {
        id: 'ent.gatewaydirectives.activity-view-summary.Note',
        defaultMessage: 'Note',
    },
    noActivitiesFound: {
        id: 'ent.gatewaydirectives.activity-schedule.No Activities found.',
        defaultMessage: 'No Activities found.',
    },
    dueAfterThisWeek: {
        id: 'ent.gatewaydirectives.activity-schedule.Due after this week',
        defaultMessage: 'DUE AFTER THIS WEEK',
    },
    overdue: {
        id: 'ent.gatewaydirectives.activity-schedule.Overdue',
        defaultMessage: 'OVERDUE',
    },
    dueToday: {
        id: 'ent.gatewaydirectives.activity-schedule.Due Today',
        defaultMessage: 'DUE TODAY',
    },
    dueTomorrow: {
        id: 'ent.gatewaydirectives.activity-schedule.Due Tomorrow',
        defaultMessage: 'DUE TOMORROW',
    },
    dueThisWeek: {
        id: 'ent.gatewaydirectives.activity-schedule.Due this week',
        defaultMessage: 'DUE THIS WEEK',
    },
    completedActivity: {
        id: 'ent.gatewaydirectives.activity-schedule.Completed',
        defaultMessage: 'Completed',
    },
});
